import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
    console.log(error, info);
    console.log('CATCH ERROR BOUNDARY');
  }

  render() {
    const { brandOptions } = window._app;
    const { title, phoneNumber, isBeaches } = brandOptions;
    let phoneNumberText = '1(888) 726-3257';

    if(isBeaches) {
      phoneNumberText = '1(888) 232-2437';
    }

    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-boundary">
          <h3 className="error-title-new">
            Sorry, we are experiencing technical difficulties.
          </h3>
          <p className="error-message-new">We will be back shortly. Please contact us at</p>
          <a className="d-block call-center-link-new" href={`tel:${phoneNumber}`}>{`1-888-${title.toUpperCase()} or ${phoneNumberText}`}</a>
        </div>);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./js/components/global/ErrorBoundary.js